import {
    Alert, Autocomplete, Button, ButtonGroup, CircularProgress, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, Grid, IconButton, InputAdornment,
    InputBase, LinearProgress, MenuItem, Paper, Select, Snackbar, TextField
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import TextsmsIcon from '@mui/icons-material/Textsms';
import SendIcon from '@mui/icons-material/Send';
import { useParams } from 'react-router-dom';
import { getDataCrearTicket, getTrabajadores, postTarea, postTegistrarTicket, postTickets } from '../../../services/apis';
import AutocompleteList from '../../../utils/componentes-utiles/AutocompleteList';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CheckIcon from '@mui/icons-material/Check';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import LoopIcon from '@mui/icons-material/Loop';
import useTicketReader from '../../../utils/componentes-utiles/useTicketReader';
import LinearProgressWithLabel from '../../../utils/componentes-utiles/LinearProgressWithLabel';
import { Pasos } from '../../../utils/componentes-utiles/Pasos';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

export const CrearTicket = ({ open, setOpen, backgroundCard, textColor }) => {
    const params = useParams()
    const obtenerFechaActual = () => {
        const fechaActual = new Date();
        return fechaActual.toISOString(); // Retorna la fecha y hora actual en formato ISO string
    };
    const [camara, setCamara] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
    const [monedas, setMonedas] = useState([]);
    const [empleados, setEmpleados] = useState();
    const [proyectos, setProyectos] = useState();
    const [opTrabajadores, setOpTrabajadores] = useState([]);

    const [proyectosSelec, setProyectosSelect] = useState({ label: "Seleccione un Proyecto", value: "0" });

    const [empleadosSelec, setEmpleadosSelect] = useState({ label: "Seleccione Empleados", value: "0" });

    //pasos
    const [paso, setPaso] = useState(0);
    const steps = ['', '', '', '', ''];

    const handleClose = () => {
        setOpen(false);
    };

    const { status, total, progress } = useTicketReader(imagenSeleccionada);

    const param = useParams();
    const [errorAlert, setErrorAlert] = useState(false);
    const [clienteSelec, setClienteSelec] = useState({ label: "Seleccione un Proyecto", value: "0" });
    const [trabajadorSelec, setTrabajadorSelec] = useState([]);
    const [ticket, setTicket] = useState({
        idProyecto: param.id,
        descripcion: null,
        fecha: obtenerFechaActual(),
        importe: null,
        moneda: 1,
        usuario: "admin",
        ubicacion_latitud: "2323233",
        ubicacion_longitud: "213213213123"
    });

    useEffect(() => {
        const ticketNuevo = { ...ticket, importe: total };
        setTicket(ticketNuevo);
        cargarCrearTicket();
        cargarTrabajadores();
    }, [total])

    const cargarCrearTicket = async () => {
        try {
            const response = await getDataCrearTicket();
            setMonedas(response.data.monedas);
            if (response.data.proyectos) {
                let temp = response.data.proyectos;
                const newTmp = temp.map((item, index) => ({
                    label: item.nombre,
                    value: item.id
                }))
                setProyectos(newTmp);
                const selectedId = params?.id;
                if (selectedId) {

                    const proyectoEncontrado = newTmp.find(proyecto => proyecto.value == selectedId);
                    setProyectosSelect(proyectoEncontrado || null);
                } else {
                    setProyectosSelect(null); // O algún valor por defecto
                }
            }

        } catch (error) {
            console.log(error);
        }


    }

    const cargarTrabajadores = async () => {
        try {
            const response = await getTrabajadores();
            const tmp = [...response.data];
            const newTmp = tmp.map((item, index) => ({
                label: item.nombre,
                value: item.id
            }))
            setOpTrabajadores(newTmp);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    const handleChange = (event) => {
        const tareaNueva = { ...ticket, [event.target.name]: event.target.value };
        setTicket(tareaNueva);
        setErrorAlert(false)
    };

    const isNullInObject = (obj) => {
        // Lista de campos que se deben omitir en la validación
        const camposExcepcion = ['localizacion', 'minutos', 'id_cliente', 'id_proyecto'];
        return Object.keys(obj).every(key => {
            if (camposExcepcion.includes(key)) {
                return true;
            }
            return obj[key] !== null && obj[key] !== '' && obj[key] != 0;
        });
    };

    const crearTarea = async () => {
        const nuevaTareaTmp = { ...ticket };
        nuevaTareaTmp.id_cliente = clienteSelec.value;
        nuevaTareaTmp.trabajadores = trabajadorSelec;
        let tempLocal = await localizar();
        nuevaTareaTmp.longitud = tempLocal ? tempLocal.longitude : null;
        nuevaTareaTmp.latitud = tempLocal ? tempLocal.latitude : null;
        nuevaTareaTmp.imagen = imagenSeleccionada;


        const tareaComprobada = isNullInObject(nuevaTareaTmp);

        if (!tareaComprobada) {
            console.error("Hay campos vacíos o no válidos en la tarea");
            setErrorAlert(true);
            return; // Detener la ejecución si hay campos no válidos
        }

        try {
            const response = await postTickets(nuevaTareaTmp);

            if (response.success === true) {
                handleClose();

                // cargarTareas();
                setTicket({
                    idProyecto: params.id,
                    descripcion: null,
                    fecha: obtenerFechaActual(),
                    importe: null,
                    moneda: 1,
                    usuario: "admin"
                });
                setClienteSelec({ label: "Seleccione un Cliente", value: "0" });
                setTrabajadorSelec([]);
                handleClose();

            }
        } catch (error) {
            console.error("Error al cargar tickets", error);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        crearTarea();
    };

    const registrarImagen = async (imagen) => {
        try {
            const response = await postTegistrarTicket(ticket, imagen);
            if (response.success === true) {
                setCamara(true);

            }
        } catch (error) {
            console.error("Error al cargar tickets", error);
        }
    }

    //funciones viejas//////////////////////////////



    const handleFileInputChange = (event) => {
        const file = event.target.files[0];
        registrarImagen(event.target.files[0]);

        const reader = new FileReader();
        setPaso(1);
        reader.onloadend = () => {
            setImagenSeleccionada(reader.result);

        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };
    const fileInputRef = useRef(null);

    const handleLoopIconClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const localizar = () => {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        resolve({ latitude, longitude });
                    },
                    (error) => {
                        reject(`Error Code = ${error.code} - ${error.message}`);
                    }
                );
            } else {
                reject('Geolocation is not supported by this browser.');
            }
        });
    };


    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
            fullWidth
            maxWidth={'md'}
            scroll='body'
        >

            <DialogContent style={{
                backgroundColor: `#${backgroundCard}`,
                color: textColor,
                minHeight: '40vh',

            }}>
                <Grid container xs={12} direction="column" alignItems={"center"} justifyContent={"space-between"}>
                    <Grid container xs={12} direction="row" alignItems={"center"} justifyContent={"space-between"}>

                        <div id="form-dialog-title">
                            <h3>Subir Ticket</h3>
                        </div>
                        <div className='flex-right'>
                            <CancelIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                        </div>
                    </Grid>
                    <Grid container xs={12} direction={'row'} alignItems={'center'}>

                        <Grid container xs={1} >
                            <Button onClick={() => setPaso(paso - 1)} color="primary" disabled={paso === 0 ? true : false}>
                                <NavigateBeforeIcon ></NavigateBeforeIcon>
                            </Button>
                        </Grid>
                        <Grid container xs={10} >
                            <Pasos steps={steps} pasoActivo={paso}></Pasos>
                        </Grid>
                        <Grid container xs={1} >
                            <Button onClick={() => setPaso(paso + 1)} disabled={paso === 0 ? !imagenSeleccionada : paso === 1 ? !ticket.importe || !ticket.moneda : paso === 2 ? !ticket.importe || !ticket.moneda : false} color="primary">
                                <NavigateNextIcon ></NavigateNextIcon>
                            </Button>
                        </Grid>

                    </Grid>

                    <form onSubmit={handleSubmit}>
                        {paso === 3 && (
                            <Grid container spacing={2} direction="column">
                                <Grid item>
                                    <TextField
                                        label="Asunto"
                                        variant="outlined"
                                        multiline
                                        fullWidth
                                        name="asunto"
                                        value={ticket.asunto}
                                        onChange={handleChange}
                                        required
                                    />
                                </Grid>
                                <Grid item>
                                    <TextField
                                        label="Descripción"
                                        variant="outlined"
                                        multiline
                                        rows={4}
                                        fullWidth
                                        name="descripcion"
                                        value={ticket.descripcion}
                                        onChange={handleChange}
                                        required
                                    />
                                </Grid>
                            </Grid>
                        )}

                        <div className='tickets-container'>

                            {paso === 0 && (
                                <div>
                                    {/* {!camara && !imagenSeleccionada && ( */}
                                    <>
                                        <h3>Haz una foto o subela</h3>
                                        <Grid container xs={12} justifyContent={'center'}>
                                            <Button variant="contained" onClick={handleLoopIconClick}>
                                                <CameraAltIcon className='flex-center' />
                                            </Button>
                                        </Grid>
                                        <input
                                            ref={fileInputRef}
                                            type='file'
                                            style={{ display: 'none' }}
                                            accept='image/*'
                                            onChange={handleFileInputChange}
                                        />
                                    </>
                                    {/* )} */}
                                </div>
                            )}
                            {paso === 1 && (
                                <div>
                                    {/* {(imagenSeleccionada && camara) && ( */}
                                    <Grid container direction="column" alignItems={"center"} justifyContent={"center"} padding={"1em"}>
                                        <Grid container xs={8} direction={'row'} justifyContent={'center'} >
                                            <img src={imagenSeleccionada} alt="Imagen seleccionada" className='confirmar-imagen' />
                                        </Grid>
                                        <Grid container xs={8} padding={"1em"} direction={'row'} justifyContent={'center'} >
                                            <LinearProgressWithLabel progress={progress} />
                                        </Grid>
                                        <Grid container xs={12} direction={'row'} justifyContent={'center'}>
                                            <div className='ticket-element'>
                                                <TextField id="filled-basic" label="importe" name="importe" onChange={handleChange} value={ticket.importe} variant="filled" type='number' className='textfield' />
                                            </div>

                                            <div className='ticket-element'>
                                                <Select
                                                    labelId="label"
                                                    id="select"
                                                    name='moneda'
                                                    value={ticket.moneda}
                                                    onChange={handleChange}
                                                >
                                                    {monedas.map((moneda) => (
                                                        <MenuItem key={moneda.id} value={moneda.id}>{moneda.simbolo}</MenuItem>
                                                    ))}
                                                </Select>
                                            </div>
                                        </Grid>
                                        <Grid container xs={12} direction="row" alignItems={"center"} padding={"1em"} justifyContent={"center"}>
                                            <ButtonGroup disabled={!ticket.importe || !total} variant="contained" aria-label="Basic button group">
                                                <Button type={'filled'} onClick={() => {
                                                    setCamara(false);
                                                    setPaso(2);
                                                }}>
                                                    <CheckIcon className='flex-center' />
                                                </Button>
                                                <Button className='button-aux' onClick={handleLoopIconClick}>
                                                    <LoopIcon className='flex-center' />
                                                </Button>
                                                <div>
                                                    <input
                                                        ref={fileInputRef}
                                                        type='file'
                                                        style={{ display: 'none' }}
                                                        accept='image/*'
                                                        onChange={handleFileInputChange}
                                                    />
                                                </div>
                                                <Button className='button-aux' onClick={() => { setImagenSeleccionada(null); setCamara(false); }}>
                                                    <DeleteForeverIcon className='flex-center' />
                                                </Button>
                                            </ButtonGroup>
                                        </Grid>
                                    </Grid>
                                    {/* )} */}
                                </div>
                            )}
                            {paso == 2 && (
                                <Grid container xs={12} spacing={2} direction="column" justifyContent={'center'} alignContent={'center'}>

                                    <Grid item>
                                        <Autocomplete
                                            className={proyectos ? "inputDateInput" : 'inputDateInput-empty'}
                                            disablePortal
                                            id="combo-box-demo"
                                            options={proyectos}
                                            sx={{ width: 300 }}
                                            value={proyectosSelec}
                                            onChange={(event, newValue) => setProyectosSelect(newValue)}
                                            renderInput={(params) => <TextField {...params} label="Obligatorio*" />}
                                        />
                                    </Grid>

                                </Grid>

                            )}
                            {paso == 4 && (
                                <Grid container xs={12} spacing={2} direction="column" justifyContent={'center'} alignContent={'center'}>

                                    <Grid item>
                                        <h4>Selecciona los Empleados colaboradores</h4>
                                        <AutocompleteList array={opTrabajadores} setArray={setTrabajadorSelec} />
                                    </Grid>
                                </Grid>
                            )}
                        </div>
                    </form>
                </Grid>
            </DialogContent >
            <DialogActions style={{
                backgroundColor: `#${backgroundCard}`,
                color: textColor
            }}>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>




                <Button onClick={handleSubmit} disabled={paso !== 4} color="primary" variant="contained">
                    Subir Ticket
                </Button>

            </DialogActions>
            {
                errorAlert && (
                    <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Falta rellenar algún campo obligatorio"} />
                )
            }
        </Dialog >
    );
};
